export default function Gallery() {
  const images = [
    {
      id: 1,
      title: 'Close-Up Interaction',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/dd5c6edc6b799d0c699b97789b1cd8d2.png'
    },
    {
      id: 2,
      title: 'Large Stage Audience',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/7be884ee18fa2962d580e48423b120e1.png'
    },
    {
      id: 4,
      title: 'Guest Reactions',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/c132960dcde059e2f7ce58544281166a.jpeg'
    },
    {
      id: 5,
      title: 'VIP Entertainment',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/836f27da7aa8a97bb354fd73b4dec485.jpeg'
    }
  ];

  return (
    <section className="relative py-32 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Experience <span className="bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">Gallery</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Moments from corporate events and MICE gatherings worldwide
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((item, index) => (
            <div 
              key={item.id}
              className={`group relative overflow-hidden rounded-2xl ${
                index === 0 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${
                index === 0 ? 'h-[600px]' : 'h-[280px]'
              }`}>
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}